module.exports = __webpack_public_path__ + "static/img/Icon.16ee07b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icon.png
// module id = S5/w
// module chunks = 1